import React from 'react';
import { Collapse, Typography } from 'antd';
var {
  Title
} = Typography;
var {
  Panel
} = Collapse;
export default function Setup(_ref) {
  var {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Collapse, {
    bordered: true
  }, /*#__PURE__*/React.createElement(Collapse.Panel, {
    header: "Setup",
    headerLevel: 1
  }, children));
}